import React from 'react';
import { AvailableAccountList, ComponentInfo } from '@components';
import { useServiceResponse } from '@store';
import { useAvailableAccountListHelper } from './availableAccountList.helper';
import { Box, Typography } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const AvailableAccountListPlaceholder: React.FC = () => {
	const t = useTranslation();
	const { retrieveAccounts } = useServiceResponse();
	const { getAvailableAccountsList } = useAvailableAccountListHelper();

	const accounts = getAvailableAccountsList(retrieveAccounts);

	return (
		<ComponentInfo name="AvailableAccountListPlaceholder">
			{!!accounts.length && (
				<>
					<Box styles={{ margin: rem(40, 0, 16) }}>
						<Typography appearance="body-100-04">
							{t('placeholders.resumeAndAuthorization.accountsAvailable.title')}
						</Typography>
					</Box>
					<AvailableAccountList accounts={accounts} />
				</>
			)}
		</ComponentInfo>
	);
};
